/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-11T17:16:49.217
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveRentLegalEntity,
	getRentLegalEntityCreateInit,
	getRentLegalEntityEditInit,
	getRentLegalEntityView,
	deleteRentLegalEntity
} from '@api/rentmanage/RentLegalEntity';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getRentLegalEntityCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentLegalEntityCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentLegalEntityEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentLegalEntityEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentLegalEntity({}, RentLegalEntity) {
			return new Promise((resolve, reject) => {
				saveRentLegalEntity(RentLegalEntity)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getRentLegalEntityView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentLegalEntityView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteRentLegalEntity({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentLegalEntity({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
